export default "__VITE_ASSET__3_rW3oJo__"